import { lazy } from 'react';

export const LazyIntegrationSendTemplatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-send-template-page" */ './integration-send-template-page'
    ),
);
